import React from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';

import { Spacer } from '@motorway/motorway-component-library';

import { applySessionReplayMask } from 'Services/datadog/datadogRum';
import { MASKED_EVENT_VALUES } from 'Services/datadog/datadogRum.const';
import useVehicleFilterStore from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';

import { arrayNoEmptyValue } from '../VehicleList.helpers';

import { formatDistanceRange, formatFilterRange, MinMaxFilters } from './Filters.helpers';
import SliderFilterView from './SliderFilterView';

import styles from './NewFilters.module.scss';

T.setTexts(require('../../texts.json'));

const { dealer } = MASKED_EVENT_VALUES;
const privacyParams = { postcode: applySessionReplayMask({ maskedActionName: dealer.postcode }) };

const SlidersSection = (props) => {
	const { dealerLatLng, dealerPostcode } = props;

	const setValue = useVehicleFilterStore((store) => store.setValue);
	const unsetValue = useVehicleFilterStore((store) => store.unsetValue);
	const filters = useVehicleFilterStore((store) => store.filters);

	const onChange =
		(
			// eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
			[min, max],
			[fieldStart, fieldEnd], // eslint-disable-next-line no-unused-vars
		) =>
		(start, end) => {
			// eslint-disable-line no-unused-vars
			if (fieldStart && filters[fieldStart] !== start && start !== min) {
				setValue({ id: fieldStart, value: start });
			}

			if (fieldStart && start === min) {
				unsetValue({ id: fieldStart });
			}

			if (filters[fieldEnd] !== end && end !== max) {
				setValue({ id: fieldEnd, value: end });
			}

			if (end === max) {
				unsetValue({ id: fieldEnd });
			}
		};

	return (
		<>
			{/* PRICE */}
			<SliderFilterView
				clearMax
				display={formatFilterRange('£')}
				filterLabels={['displayPriceFrom', 'displayPriceTo']}
				from={filters.displayPriceFrom}
				id="reservePrice"
				increment={MinMaxFilters.price.INCREMENT}
				max={MinMaxFilters.price.MAX}
				min={MinMaxFilters.price.MIN}
				onChange={onChange}
				title={T.translate('vehicleList.filters.reservePrice')}
				to={filters.displayPriceTo}
			/>
			<Spacer showDivider className={styles.divider} size="zero" />
			{/* MILEAGE */}
			<SliderFilterView
				display={formatFilterRange('miles', true, false, MinMaxFilters.mileage.MAX)}
				filterLabels={['mileageFrom', 'mileageTo']}
				from={filters.mileageFrom}
				id="mileage"
				increment={MinMaxFilters.mileage.INCREMENT}
				max={MinMaxFilters.mileage.MAX}
				min={MinMaxFilters.mileage.MIN}
				onChange={onChange}
				title={T.translate('vehicleList.filters.mileage')}
				to={filters.mileageTo}
			/>
			<Spacer showDivider className={styles.divider} size="zero" />
			{/* AGE */}
			<SliderFilterView
				display={formatFilterRange('years', true, false, 20)}
				filterLabels={['ageFrom', 'ageTo']}
				from={filters.ageFrom}
				id="age"
				max={MinMaxFilters.age.MAX}
				min={MinMaxFilters.age.MIN}
				onChange={onChange}
				title={T.translate('vehicleList.filters.age')}
				to={filters.ageTo}
			/>

			{/* DISTANCE */}
			{arrayNoEmptyValue(dealerLatLng) && (
				<>
					<Spacer showDivider className={styles.divider} size="zero" />
					<SliderFilterView
						disabledFrom
						display={formatDistanceRange}
						filterLabels={[null, 'maxDistance']}
						from={MinMaxFilters.distance.MIN}
						id="distance"
						increment={MinMaxFilters.distance.INCREMENT}
						max={MinMaxFilters.distance.MAX}
						min={MinMaxFilters.distance.MIN}
						onChange={onChange}
						title={
							<div className={styles.distanceTitle}>
								<span>{T.translate('vehicleList.filters.distanceFromPostcode')}</span>
								<span {...privacyParams.postcode}>{dealerPostcode}</span>
							</div>
						}
						to={filters.maxDistance}
					/>
				</>
			)}
		</>
	);
};

SlidersSection.propTypes = {
	dealerLatLng: PropTypes.arrayOf(PropTypes.number).isRequired,
	dealerPostcode: PropTypes.string.isRequired,
};

export default SlidersSection;
